import { cleanCounterpartyName, platformDisplayOf } from './platformDisplay';
import type { ExpenseCategory, Movement } from '../model/period';
import { toSentenceCase } from './formatters';

const CATEGORY_TITLES: Partial<Record<ExpenseCategory, string>> = {
	gasolina: 'Gasolinera',
	lavado: 'Autolavado',
	llantas: 'Taller mecánico',
	refacciones: 'Refaccionaria',
	mantenimiento: 'Taller mecánico',
};

export const displayNameOf = (rawName: string) => platformDisplayOf(rawName)?.display ?? toSentenceCase(cleanCounterpartyName(rawName));

export const counterpartyOf = (movement: Movement): { name: string; logo?: string; legalName?: string } => {
	if (movement.reportedByUser) return { name: movement.name };
	const legalName = toSentenceCase(cleanCounterpartyName(movement.name));
	const platform = platformDisplayOf(movement.name);
	if (platform) return { name: platform.display, logo: platform.logo, legalName };
	const category = movement.category && CATEGORY_TITLES[movement.category];
	return category ? { name: category, legalName } : { name: legalName };
};
